module.exports = __webpack_public_path__ + "static/media/pic2.e0894d93.webp";